'use client'

import {Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi} from '@/components/ui/carousel'
import Image from 'next/image'
import {useEffect, useState} from 'react'

interface ImageInfo {
  path: string
  name: string
}

interface Props {
  images: ImageInfo[]
}

export const MunicipalityCarousel = ({images}: Props) => {
  const [api, setApi] = useState<CarouselApi>()
  const [shuffledImages, setShuffledImages] = useState(images)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      const shuffled = [...images]
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
      }
      setShuffledImages(shuffled)
    }, 0)

    return () => window.clearTimeout(timeoutId)
  }, [images])

  useEffect(() => {
    if (!api) return

    const interval = setInterval(() => {
      api.scrollNext()
    }, 3000)

    return () => clearInterval(interval)
  }, [api])

  return (
    <div className="w-full px-20">
      <Carousel
        setApi={setApi}
        opts={{
          align: 'start',
          loop: true,
        }}
        className="w-full"
      >
        <CarouselContent>
          {shuffledImages.map((image, index) => (
            <CarouselItem key={index} className="md:basis-1/3 lg:basis-1/5 my-2">
              <div className="relative h-48 rounded-lg overflow-hidden">
                <Image
                  src={image.path}
                  alt={image.name}
                  fill
                  sizes="(min-width: 1024px) 20vw, (min-width: 768px) 33vw, 100vw"
                  className="object-contain"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden md:flex" />
        <CarouselNext className="hidden md:flex" />
      </Carousel>
    </div>
  )
}
